
<div appFadeSlideInOnce="app-stats-widget">
  <div
    class="rounded-xl p-5 shadow-md bg-white dark:bg-[#111] text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 mb-0 transition-transform transform hover:scale-105 hover:shadow-lg duration-300 ease-in-out cursor-pointer"
    (click)="irARuta()"
  >
    <div class="flex justify-between mb-4">
      <div>
        <span class="block text-gray-500 dark:text-gray-400 font-medium mb-4">{{ titulo }}</span>
        <div class="font-medium text-xl">{{ subtitulo }}</div>
      </div>
      <div
        class="flex items-center justify-center rounded-border"
        [ngStyle]="{ 'background-color': iconBg }"
        style="width: 2.5rem; height: 2.5rem"
      >
        <i
          [class]="icon"
          [ngStyle]="{ color: iconColor }"
          class="!text-xl"
        ></i>
      </div>
    </div>
    <span class="text-primary font-medium">{{ lastActionDate }}</span>
    <span class="text-gray-500 dark:text-gray-400">{{ actionText }}</span>
  </div>
</div>
